// Copyright (c) 2021 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import AuditLogTable from './components/auditlog-table';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import InputWithFaIcon from '../../shared/components/labeled-input-with-fa-icon';
import PropTypes from 'prop-types';
import SimpleMultipleEntryPopup from '../../shared/components/simple-multiplentry-popup';
import { connect } from 'react-redux';
import { filterEmpty } from '../../shared/services/common-functions';
import { getAuditLog } from './repositories';

import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class AuditLog extends Component {

    state = {
        result: null,
        orderNumbers: '',
        racfId: '',
        isPopupOpen: false,
        popupName: '',
        popupPropertyName: '',
        popupPropertyValue: ''
    };

    updateSearchInput = event => {

        const { value } = event.target;

        this.setState( {
            orderNumbers: value
        } );

    };

    updateRacfIdSearchInput = event => {

        const { value } = event.target;

        this.setState( {
            racfId: value
        } );

    };

    updateMultiEntryInput = event => {

        const { value } = event.target;
        this.setState( {
            orderNumbers: value
        } );

    };

    onClosePopup= () => {

        this.setState( {
            isPopupOpen: false
        } );

    };

    initiatePopup = propertyName => {

        this.setState( {
            isPopupOpen: true,
            popupPropertyName: propertyName,
            popupPropertyValue: this.state[propertyName]
        } );

    };

    validatePinOrPip = () => {

        const validEntry = true;
        return validEntry;

    };

    noOfEntries = entries => filterEmpty( entries ).length;

    multiEntryValidation = () => {

        const validEntry = true;
        return validEntry;

    };

    numberCount = propertyVal => {

        const match = propertyVal.search( ',' ) > 0 ? true : /\r|\n/.exec( propertyVal ) !== null;

        return match && this.noOfEntries( propertyVal ) > 1;

    };

    validateMultiEntries = () => {

        this.setState( {
            isValidEntry: true
        } );
        return true;

    };

    handleSubmit = () => {

        const order = this.state.orderNumbers.replace( /\n/g, ',' )
            .split( ',' ).map( item => item.trim() ).filter( n => n );
        const racfId = this.state.racfId.toString().toUpperCase();

        this.refresh( order, racfId );

    };

    refresh ( orderNumbers, racfId ) {

        this.props.increaseCounter();
        getAuditLog( orderNumbers, racfId )
            .then( response => {

                this.setState( {
                    result: response
                } );

                this.props.decreaseCounter();

            } )
            .catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            orderNumbers, racfId, result, isValidEntry, isPopupOpen,
            popupPropertyName, popupPropertyValue
        } = this.state;

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />

                <main>
                    <section className="section-container">
                        <div className="atp-top-options auditlog-top-options">
                            <div className="select-options">
                                {!this.numberCount( orderNumbers ) && (
                                    <InputWithFaIcon
                                        className="Order"
                                        name="orderNumbers"
                                        isEditable={true}
                                        label="Order Numbers"
                                        maxLength={12}
                                        value={orderNumbers}
                                        onChange={this.updateSearchInput}
                                        iconClassName="fa-plus-square"
                                        type="text"
                                        onIconClick={this.initiatePopup.bind( this )}
                                    />
                                )}
                                {isValidEntry && this.noOfEntries( orderNumbers ) >= 2 && (
                                    <div className="rows three-cols">
                                        <div className="form-group order-numbers edit-less">
                                            <label>Order Number</label>
                                            <div>
                                                <span className="pull-left">
                                                    {` ${this.noOfEntries( orderNumbers )} Selected`}
                                                </span>
                                                <span className="pull-right multipleStyle">
                                                    <button
                                                        className="edit-button"
                                                        type="button"
                                                        onClick={this.initiatePopup.bind( this )}
                                                    >
                                                        {' '}
                                                        Edit Selection{' '}
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>

                            <div className="select-options">
                                { (
                                    <InputWithFaIcon
                                        className="Order"
                                        name="racfId"
                                        isEditable={true}
                                        label="RACF Id"
                                        maxLength={7}
                                        value={racfId}
                                        onChange={this.updateRacfIdSearchInput}

                                        type="text"

                                    />
                                )}

                                {( this.noOfEntries( orderNumbers ) >= 1 || racfId !== '' ) && (
                                    <span className="submit-button">
                                        {' '}
                                        <button
                                            className="primary-button sub-button"
                                            type="button"
                                            onClick={this.handleSubmit.bind( this )}
                                        >
                                            Submit
                                        </button>
                                    </span>
                                )}
                            </div>
                        </div>

                        <SimpleMultipleEntryPopup
                            panelName="Order"
                            isOpen={isPopupOpen}
                            onClose={this.onClosePopup}
                            onUpdateProperty={this.updateMultiEntryInput.bind( this.props )}
                            propertyName={popupPropertyName}
                            propertyValue={popupPropertyValue}
                            onApplyValidate={this.validateMultiEntries.bind( this )}
                            validateEntry={this.validatePinOrPip.bind( this )}
                            isValidEntry={isValidEntry}
                            multiEntryValidation={this.multiEntryValidation.bind( this )}
                        />

                        {result && <AuditLogTable results={result.logDetails} />}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    accessToken: state.oktaState.oktaState.accessToken
} );

AuditLog.displayName = 'AuditLog';
AuditLog.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect( mapStateToProps, mapDispatchToProps )( withRouter( AuditLog ) );
